// Getters
export const clientes = (state) => {
  return state.clientes.data || []
}
export const clientesLoading = (state) => {
  return state.clientes.loading
}
export const clientesLastUpdate = (state) => {
  return state.clientes.lastUpdate
}

export const config = (state) => {
  return state.config.data || []
}
export const configLoading = (state) => {
  return state.config.loading
}
export const configLastUpdate = (state) => {
  return state.config.lastUpdate
}

export const signers = (state) => {
  return state.signers.data || []
}
export const signersLoading = (state) => {
  return state.signers.loading
}
export const signersLastUpdate = (state) => {
  return state.signers.lastUpdate
}

export const ips = (state) => {
  return state.ips.data || []
}
export const ipsQuestions = (state) => {
  return state.ipsQuestions.data || []
}
export const ipsLoading = (state) => {
  return state.ips.loading
}
export const ipsLastUpdate = (state) => {
  return state.ips.lastUpdate
}

export const forms = (state) => {
  return state.forms.data || []
}
export const formsLoading = (state) => {
  return state.forms.loading
}
export const formsLastUpdate = (state) => {
  return state.forms.lastUpdate
}

export const formsAnswer = (state) => {
  return state.formsAnswer.data || []
}
export const formsAnswerLoading = (state) => {
  return state.formsAnswer.loading
}
export const formsAnswerLastUpdate = (state) => {
  return state.formsAnswer.lastUpdate
}

export const questions = (state) => {
  return state.questions.data || []
}
export const questionsLoading = (state) => {
  return state.questions.loading
}
export const questionsLastUpdate = (state) => {
  return state.questions.lastUpdate
}

export const formClient = (state) => {
  return state.formClient.data || []
}
export const formClientLoading = (state) => {
  return state.formClient.loading
}
export const formClientLastUpdate = (state) => {
  return state.formClient.lastUpdate
}
export const kitDocumentos = (state) => {
  return state.kitDocumentos.data || []
}
export const kitDocumentosLoading = (state) => {
  return state.kitDocumentos.loading
}
export const kitDocumentosLastUpdate = (state) => {
  return state.kitDocumentos.lastUpdate
}

export const dataAppCliente = (state) => {
  return state.dataAppCliente.data || []
}
export const dataAppClienteLoading = (state) => {
  return state.dataAppCliente.loading
}
export const dataAppClienteLastUpdate = (state) => {
  return state.dataAppCliente.lastUpdate
}

export const kycClassification = (state) => {
  return state.kycClassification.data || {}
}
export const kycClassificationLoading = (state) => {
  return state.kycClassification.loading
}
export const kycClassificationLastUpdate = (state) => {
  return state.kycClassification.lastUpdate
}

export const pendenciasIpsKyc = (state) => {
  return state.pendenciasIpsKyc.data || { exige_ips_kyc: false, clientes: [] }
}

export const pendenciasIpsKycLoading = (state) => {
  return state.pendenciasIpsKyc.loading
}

export const pendenciasIpsKycLastUpdate = (state) => {
  return state.pendenciasIpsKyc.lastUpdate
}
